// extracted by mini-css-extract-plugin
module.exports = {"linksToPages":"NavigationHeader_linksToPages__JWfNa","navigation_header":"NavigationHeader_navigation_header__1pK5y","searchBar":"NavigationHeader_searchBar__tKERT"};